import { Component, HostBinding } from '@angular/core';
import { UxAppShellService, consumeEvent } from '@eui/core';
import { BaseDirective } from '../../base.directive';

@Component({
    selector: 'eui-sidebar-toggle',
    templateUrl: './sidebar-toggle.component.html',
})
export class EuiSidebarToggleComponent extends BaseDirective {

    constructor(
        public asService: UxAppShellService,
    ) {
        super();
    }

    @HostBinding('class')
    get cssClasses() {
        return [
            super.getCssClasses('eui-sidebar-toggle'),
        ].join(' ').trim();
    }

    onToggleSidebar(event: any) {
        this.asService.sidebarToggle();
        consumeEvent(event);
    }
}
